import React, { useState, useEffect } from "react";
import {
  getDocs,
  addDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  limit,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import { useAuth } from "../context/AuthContext";
import { getSubCollection } from "../utils/getSubCollection";
import PedidoForm from "./PedidoForm";
import TablaPedidos from "./TablaPedidos";
import PreviaPedidos from "./PreviaPedidos";

function NuevoPedido({ mostrarBotonNuevo }) {
  const { user, teamOwnerId } = useAuth();
  const ownerUid = teamOwnerId || user.uid;

  const [ordenes, setOrdenes] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [numeroOrden, setNumeroOrden] = useState(1);

  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [mostrarPrevia, setMostrarPrevia] = useState(false);
  const [ordenSeleccionada, setOrdenSeleccionada] = useState(null);

  useEffect(() => {
    // 1) Cargar clientes
    const clientesRef = getSubCollection(ownerUid, "clientes");
    getDocs(clientesRef).then((snap) =>
      setClientes(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );

    // 2) Calcular siguiente número de orden
    const pedidosRef = getSubCollection(ownerUid, "pedidos");
    const q = query(pedidosRef, orderBy("numeroOrden", "desc"), limit(1));
    getDocs(q).then((snap) => {
      if (!snap.empty) {
        const maxNum = snap.docs[0].data().numeroOrden || 0;
        setNumeroOrden(maxNum + 1);
      }
    });

    // 3) Sincronizar órdenes en real‐time
    const unsubscribe = onSnapshot(pedidosRef, (snap) => {
      setOrdenes(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsubscribe();
  }, [ownerUid]);

  const activarFormulario = () => {
    setOrdenSeleccionada(null);
    setMostrarFormulario(true);
  };

  const guardarOrden = async (ordenData, modoEdicion, ordenId) => {
    const pedidosRef = getSubCollection(ownerUid, "pedidos");
    if (modoEdicion && ordenId) {
      // — Actualizar existente —
      const ref = doc(pedidosRef, ordenId);
      await updateDoc(ref, ordenData);
    } else {
      // — Crear nuevo —
      await addDoc(pedidosRef, {
        ...ordenData,
        ownerId: ownerUid,
        numeroOrden,
        createdAt: serverTimestamp(),
      });
      setNumeroOrden((n) => n + 1);
    }
  };

  const verPrevia = (orden) => {
    setOrdenSeleccionada(orden);
    setMostrarPrevia(true);
  };

  return (
    <div>
      {!mostrarFormulario && mostrarBotonNuevo && (
        <button className="action-button2" onClick={activarFormulario}>
          + Nuevo
        </button>
      )}

      {mostrarFormulario ? (
        <PedidoForm
          clientes={clientes}
          orden={ordenSeleccionada}
          guardarOrden={guardarOrden}
          closeModal={() => setMostrarFormulario(false)}
        />
      ) : mostrarPrevia ? (
        <PreviaPedidos
          orden={ordenSeleccionada}
          clientes={clientes}
          numeroOrden={ordenSeleccionada?.numeroOrden}
          guardarOrden={guardarOrden}
          cerrarPrevia={() => setMostrarPrevia(false)}
        />
      ) : (
        <TablaPedidos
          ordenes={ordenes}
          clientes={clientes}
          numeroOrden={numeroOrden}
          verPrevia={verPrevia}
          guardarOrden={guardarOrden}
          setOrdenes={setOrdenes}
        />
      )}
    </div>
  );
}

export default NuevoPedido;
